<template>
  <g
    v-if="geoportal"
  >
    <title>
      {{ geoportal.name }}
    </title>
    <a
      :href="geoportal.website"
      :title="geoportal.name"
      class="countyUrl"
      target="_blank"
      rel="noopener"
      role="link"
    >
      <path
        :id="path.id"
        :d="path.path"
        :stroke="darkMode ? 'grey' : 'black'"
        class="county"
      />
    </a>
  </g>
  <g v-else>
    <path
      :id="path.id"
      :d="path.path"
      :stroke="darkMode ? 'grey' : 'black'"
    />
  </g>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'MapPath',
  props: {
    path: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState([
      'darkMode',
      'geoportals',
      'gminy'
    ]),
    geoportal: function () {
      return this.findGeoportal()
    }
  },
  methods: {
    findGeoportal: function () {
      let temp = this.geoportals.find(geoportal => geoportal.TERYT === this.path.id)
      if (typeof temp === 'undefined') {
        temp = this.gminy.find(geoportal => geoportal.TERYT === this.path.id)
      }
      return temp
    }
  }
}
</script>

<style scoped lang="sass">
  .county
    fill: #FFD600
    transition: 200ms fill

  .countyUrl:hover > .county, .countyUrl:focus > .county
    fill: #F9A825
    opacity: 1
    cursor: pointer

  .countyUrl:focus
    outline: #F9A825 dashed medium
</style>
